import {confirmPasswordReset, getAuth} from "firebase/auth";

export const resetPassword = async ({ oobCode, newPassword }) => {
  const auth = getAuth();
  await confirmPasswordReset(auth, oobCode, newPassword);
}